import {
  Heading,
  Button,
  Box,
  Flex,
  InputGroup,
  Input,
  Text,
  InputLeftAddon,
  SimpleGrid,
  Select,
  Icon,
} from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SearchIcon } from '@chakra-ui/icons';
import { FILTERS, SELECTED_COLOR, DEFAULT_COLOR } from './filters';
import { Filter } from './types';
import { titleCase } from 'title-case';

interface Props {
  selectedFilterIndex: Number;
  onSearch: (e: any) => void;
  onFilter: (index: Number) => void;
  tag?: Filter;
}

const Controls = ({ selectedFilterIndex, onFilter, onSearch }: Props) => {
  return (
    <Box>
      <Flex w={'100%'} pt={15} justifyContent="space-between" direction={{ base: 'column', lg: 'row' }}>
        <Heading mb={5} mr={5} fontSize="xl">
          Available Items
        </Heading>
        <InputGroup w={{ base: '100%', lg: 500 }}>
          <InputLeftAddon children={<SearchIcon />} />
          <Input id="item_search" onChange={onSearch} type="text" placeholder="item name" />
        </InputGroup>
      </Flex>
      <Heading mt={10} mr={5} display={{ base: 'block', lg: 'none' }} fontSize="xl">
        Filters
      </Heading>
      <Select
        value={selectedFilterIndex?.toString()}
        display={{ base: 'block', lg: 'none' }}
        onChange={(e) => {
          onFilter(parseInt(e.target.value));
        }}
        mt={5}
        placeholder="Select Category"
      >
        {FILTERS.map((filter: Filter, index: number) => (
          <option id={`filter_select_${index}`} key={index} value={index}>
            {titleCase(filter.name)}
          </option>
        ))}
      </Select>
      <SimpleGrid mt={10} display={{ base: 'none', lg: 'grid' }} columns={5} spacing={4} w={'100%'}>
        {FILTERS.map((filter: Filter, index: number) => (
          <Button
            id={`filter_button_${index}`}
            fontSize="xsm"
            colorScheme={selectedFilterIndex === index ? SELECTED_COLOR : DEFAULT_COLOR}
            onClick={() => {
              onFilter(index);
            }}
            key={index}
          >
            {filter.icon && <Icon as={FontAwesomeIcon} icon={filter.icon} />}
            <Text ml={2}>{titleCase(filter.name)}</Text>
          </Button>
        ))}
      </SimpleGrid>
    </Box>
  );
};

export default Controls;
